exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".logo_image{display:block;fill:#fff;transition:fill .2s ease-out}.logo_text{color:#fff}.logo.is-inverted .logo_image{fill:#00003c}", "", {"version":3,"sources":["/divvit-app/client/components/Logo/client/components/Logo/style.styl","/divvit-app/client/components/Logo/style.styl"],"names":[],"mappings":"AACE,YACE,cAAA,UACA,4BACA,CAEF,WACE,UAAA,CAGA,8BACE,YAAA,CCDL","file":"style.styl","sourcesContent":[".logo\n  &_image\n    display: block\n    fill: white\n    transition: fill 0.2s ease-out\n\n  &_text\n    color: white\n\n  &.is-inverted\n    .logo_image\n      fill: text-blue\n",".logo_image {\n  display: block;\n  fill: #fff;\n  transition: fill 0.2s ease-out;\n}\n.logo_text {\n  color: #fff;\n}\n.logo.is-inverted .logo_image {\n  fill: #00003c;\n}\n/*# sourceMappingURL=client/components/Logo/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/Logo/style.styl
// module id = 470
// module chunks = 0